import { z } from "zod";

/**
 * Public-facing view of `accounting_connections` (Sidequester id 454).
 * The GET endpoint strips access_token + refresh_token before returning,
 * so we don't model those here.
 */
export const accountingConnectionSchema = z.object({
  id: z.number().int(),
  company_id: z.number().int(),
  provider: z.string(),
  status: z.string(),
  scopes: z.string().optional().default(""),
  // Xano returns timestamps as epoch-ms numbers; some endpoints serialise as ISO strings.
  last_synced_at: z.union([z.string(), z.number()]).nullable().optional(),
  last_sync_status: z.string().optional().default(""),
  last_sync_error: z.string().optional().default(""),
  sync_frequency: z.string().optional().default("daily"),
  token_expires_at: z.union([z.string(), z.number()]).nullable().optional(),
  created_at: z.union([z.string(), z.number()]),
  updated_at: z.union([z.string(), z.number()]),
});
export type AccountingConnection = z.infer<typeof accountingConnectionSchema>;
